// extracted by mini-css-extract-plugin
module.exports = {"container":"DashboardMap_container__rOFrK","full":"DashboardMap_full__25KSX","closeMap":"DashboardMap_closeMap__2C7ez","active":"DashboardMap_active__3kHU1"};